import { useQuery } from 'react-query';
import api from '../services/api';
import type { LicenseState } from '@/lib/license';

/** One query for the licence: Settings › License and the shell's banner share it. */
export const LICENSE_QUERY_KEY = 'license';

export const fetchLicense = async (): Promise<LicenseState> => (await api.get<LicenseState>('/license')).data;

export function useLicenseState() {
  return useQuery(LICENSE_QUERY_KEY, fetchLicense, {
    // The licence is re-checked server-side hourly; a few minutes is fresh enough.
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    // Read afresh whenever a reader mounts (the shell once per load, the
    // License tab when opened), as the tab always did. Two readers mounting
    // together share the one request in flight.
    refetchOnMount: 'always',
    // A failed read (an endpoint that refuses a non-admin, the service down)
    // leaves the banner away rather than raising an error of its own.
    retry: false,
  });
}
